// export const host = "http://192.168.1.199:1001"; //测试线上
// export const host = "http://192.168.1.241:5000"; //李
// export const host = 'https://api.gps.gts56.com:1002' //线上
// export const host = "http://192.168.1.199:10000/wl"; //内网
export const host = "https://vapi.gts56.com/wl"; //网关
//阿里云OSShost
export const ossHost = "https://res.gts56.com/fzkj/web/front/YSB_PC/";
